import { useState } from "react";
import { format } from "date-fns";
import { id as localeId } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";

const toDate = (iso) => {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};
const YEAR_NOW = new Date().getFullYear();
const DROPDOWN_CLASSES = {
  caption_dropdowns: "flex gap-2 justify-center",
  dropdown_month: "relative inline-flex items-center",
  dropdown_year: "relative inline-flex items-center",
  dropdown: "absolute inset-0 w-full opacity-0 cursor-pointer z-10",
  caption_label: "flex items-center gap-1 rounded-md border border-slate-200 px-2.5 py-1 text-sm font-semibold capitalize",
  vhidden: "sr-only",
  day: "h-10 w-10 sm:h-9 sm:w-9 p-0 font-normal rounded-md hover:bg-emerald-50 aria-selected:opacity-100",
  day_selected: "bg-emerald-800 text-white hover:bg-emerald-800 hover:text-white focus:bg-emerald-800 focus:text-white",
  head_cell: "text-slate-500 rounded-md w-10 sm:w-9 font-normal text-[0.8rem]",
};

export const DateField = ({ value, onChange, testid, fromYear = 2015, toYear = YEAR_NOW + 20, className = "h-10" }) => {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex ${className} w-full items-center gap-2 rounded-md border border-input bg-white px-3 text-sm text-left hover:border-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-700/30`}>
          <CalendarDays className="h-4 w-4 text-emerald-800 shrink-0" />
          <span className={selected ? "text-slate-900" : "text-slate-400"}>{selected ? format(selected, "d MMMM yyyy", { locale: localeId }) : "Pilih tanggal"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testid && `${testid}-calendar`}>
        <Calendar mode="single" locale={localeId} selected={selected} defaultMonth={selected} captionLayout="dropdown-buttons" showOutsideDays={false}
          fromYear={fromYear} toYear={toYear} classNames={DROPDOWN_CLASSES}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
        <div className="flex justify-between border-t border-slate-100 px-3 py-2">
          <button type="button" className="text-sm font-semibold text-emerald-800" data-testid={testid && `${testid}-today`}
            onClick={() => { onChange(format(new Date(), "yyyy-MM-dd")); setOpen(false); }}>Hari ini</button>
          <button type="button" className="text-sm text-slate-500" onClick={() => setOpen(false)}>Tutup</button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
